import { ActionType } from 'redux-promise-middleware';
import { loadBulkSearchSpotsTransientV2, loadSpotsTransientV2, SPOTS_GET_BULK_TRANSIENT_V2, SPOTS_GET_TRANSIENT_V2, } from 'store/spots/spots-actions-v2';
import { toggleLoyaltyProgram } from 'store/filters/filters-actions';
import { LOYALTY_PROGRAM_FILTER_VALUES } from 'store/filters/loyalty-filter-utils';
export const loyaltyProgramMiddleware = ({ dispatch, getState, }) => (next) => (action) => {
    switch (action.type) {
        case `${SPOTS_GET_TRANSIENT_V2}_${ActionType.Fulfilled}`:
        case `${SPOTS_GET_BULK_TRANSIENT_V2}_${ActionType.Fulfilled}`: {
            const prevState = getState();
            const { data: { operatorLoyaltyProgram }, } = prevState.user;
            const loyaltyProgramSelected = prevState.filters.loyaltyProgram;
            // If loyalty program on or unset and no results, turn it off
            if (operatorLoyaltyProgram &&
                (loyaltyProgramSelected ===
                    LOYALTY_PROGRAM_FILTER_VALUES.UNSET ||
                    loyaltyProgramSelected ===
                        LOYALTY_PROGRAM_FILTER_VALUES.ON) &&
                action.payload.results.length < 1) {
                dispatch(toggleLoyaltyProgram(LOYALTY_PROGRAM_FILTER_VALUES.AUTOMATIC_OFF));
                if (action.type ===
                    `${SPOTS_GET_TRANSIENT_V2}_${ActionType.Fulfilled}`) {
                    dispatch(loadSpotsTransientV2(action.meta?.originalArgs || {}));
                }
                else if (action.type ===
                    `${SPOTS_GET_BULK_TRANSIENT_V2}_${ActionType.Fulfilled}`) {
                    dispatch(loadBulkSearchSpotsTransientV2(action.meta?.originalArgs || {}));
                }
            }
            else if (operatorLoyaltyProgram &&
                loyaltyProgramSelected === LOYALTY_PROGRAM_FILTER_VALUES.UNSET) {
                dispatch(toggleLoyaltyProgram(LOYALTY_PROGRAM_FILTER_VALUES.ON));
            }
            break;
        }
    }
    return next(action);
};
